import React, { useEffect, useRef, useState } from "react";
import { Input } from "reactstrap";
import { Download, PlusSquare } from "react-feather";

import { TableButton } from "components/TableButton";
import { uploadFiles } from "services/apiSupply";

export const UploadFiles = ({ row, setProducts, setLoading }) => {

  const [files, setFiles] = useState([]);
  const inputFile = useRef();

  const uploadDocument = () => {
    setLoading(true);
    const formData = new FormData();
    for (const file of files) {
      formData.append("files[]", file);
    }
    uploadFiles(row.id, formData)
      .then((res) => {
        setProducts(res);
      })
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    if (!files.length) return;
    uploadDocument();
  }, [files]);

  const getFiles = () => {
    if (inputFile) {
      inputFile.current.click();
    }
  };

  async function downloadFile(url) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = url.split('/').pop();
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  async function downloadAllFiles() {
    for (const file of row.files) {
      await downloadFile(`${process.env.REACT_APP_BASE_URL}/image.view?file=${file.key}`);
    }
  }

  return <>
    <Input
      type="file"
      id={`${row.id}_files`}
      multiple
      hidden
      innerRef={inputFile}
      onChange={(e) => setFiles(e.target.files)}
      accept=".jpeg,.jpg,.png,.pdf"
    />
    <TableButton
      Icon={PlusSquare}
      onClick={getFiles}
    />
    {row.files.length &&
      <>
        <TableButton
          Icon={Download}
          onClick={downloadAllFiles}
          title={`Скачать ${row.files.length} файлов`}
        />
        <span className="ml-2">(Файлов: {row.files.length})</span>
      </>
    }
  </>
}